export const SET_THEME = "SET_THEME";

export const SET_LAYOUT = "SET_LAYOUT";
